import React from "react";

const NotFound = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>404</h1>
      <p style={styles.text}>
        Halaman tidak ditemukan
      </p>
      <p style={styles.subText}>
        Silakan scan ulang barcode yang ada di meja
      </p>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f9f9f9",
    textAlign: "center",
    padding: "20px",
  },
  title: {
    fontSize: "72px",
    margin: "0",
    color: "#ff4d4f",
  },
  text: {
    fontSize: "20px",
    margin: "10px 0",
    fontWeight: "bold",
  },
  subText: {
    fontSize: "16px",
    color: "#666",
  },
};

export default NotFound;